import React from "react";

const TaskEnrouteActionIcon = (props) => (
    <svg className={props.className} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "En Route"}</title>
        <path
            d="M22.6441 16.5703V12.5727L19.3191 11.3976L17.0145 8.06308C16.641 7.52273 16.026 7.2002 15.3692 7.2002H13.4146H9.99994V12.0002H5.49994H0.999939V15.5002V17.5202H5.62072M22.6441 16.5703H23.319V17.5202H22.6441V16.5703ZM10.4999 17.5002H14.9999M5.62072 17.5202C5.54296 17.7026 5.49994 17.9034 5.49994 18.1143C5.49994 18.9526 6.1791 19.6333 7.01651 19.6333C7.85418 19.6333 8.53341 18.9527 8.53341 18.1143C8.53341 17.2765 7.85462 16.5988 7.01651 16.5988C6.38961 16.5988 5.85179 16.9782 5.62072 17.5202ZM20.139 18.1143C20.139 18.9527 19.4597 19.6333 18.6221 19.6333C17.7847 19.6333 17.1055 18.9526 17.1055 18.1143C17.1055 17.2765 17.7842 16.5988 18.6221 16.5988C19.4602 16.5988 20.139 17.2765 20.139 18.1143ZM12.4999 9.50024V12.0002H14.8027H17.1055L15.4999 9.50024H13.9999H12.4999Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TaskEnrouteActionIcon;
